// removed by extract-text-webpack-plugin
module.exports = {"option-select":"option-select","button-icon":"button-icon","icon":"icon","disabled":"disabled","button-select-previous":"button-select-previous","button-select-next":"button-select-next","options":"options","option":"option","active":"active"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/option-select/option-select.style.sass
// module id = +QZ5
// module chunks = 0